export enum TagAdminEnum {
  CAMPAIGN = 'campaign',
  SEGMENT = 'segments',
  TEMPLATE = 'templates',
  RULES_ENGINE = 'rules engine',
  TRIGGERS = 'triggers',
  PRODUCT = 'product',
}
